import { isKITProduct, type ProductData } from "~/domains/product/types/ProductData";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";
import type { OptionalPartDraft } from "~/features/addToCart/hooks/useAddToCartForm";
import { INVALID_PACKAGE_CODE } from "~/utils/constants";

export const mapOptionalParts4Wishlist = (parentProduct?: ProductData, optionalParts?: Dict<OptionalPartDraft>) => {
  if (!isKITProduct(parentProduct) || !optionalParts) {
    return undefined;
  }
  return Object.entries(optionalParts)
    .filter(([productCode, item]) => item.selected)
    .map(([productCode, item]) => ({
      productCode,
      quantity: parentProduct.optionalParts.find((item) => item.product.code === productCode)?.quantity ?? 1,
    }));
};

export function getFirstValidPackCode(productDescriptor: ProductDescriptor) {
  return productDescriptor.prices?.[0]?.packCode ?? INVALID_PACKAGE_CODE;
}
